// extracted by mini-css-extract-plugin
export default {"invisible":"numberWithDisappearingButton_invisible__Wuky1","visible":"numberWithDisappearingButton_visible__oOEwL"};